export default __webpack_public_path__ + "static/media/Printer.3a8dc4ac.svg";